import { createContext, useState } from 'react'

export const FilteredComplaintsContext = createContext()

export const FilteredComplaintsContextProvider = ({ complaints = [], children }) => {
  const [filters, setFilters] = useState({
    infractionType: [],
    infractionLevel: [],
    nextStep: [],
    state: [],
    protocolType: []
  })

  const [searchTitle, setSearchTitle] = useState('')

  const matchesFilter = (complaint, filterKey, selectedValues) => {
    return selectedValues.length === 0 || selectedValues.includes(complaint[filterKey])
  }

  const filteredComplaints = complaints.filter(complaint =>
    Object.entries(filters).every(([key, selectedValues]) => matchesFilter(complaint, key, selectedValues))
  )

  const finalComplaints = filteredComplaints.filter(complaint =>
    complaint.title.toLowerCase().includes(searchTitle.toLowerCase())
  )

  return (
    <FilteredComplaintsContext.Provider value={{
      filters,
      setFilters,
      filteredComplaints: finalComplaints,
      searchTitle,
      setSearchTitle
    }}
    >
      {children}
    </FilteredComplaintsContext.Provider>
  )
}
